module.exports = __webpack_public_path__ + "static/media/Diana_Vanermi_Bolanos_Reyes_2.d0d55e75.png";